export const ToolCallIndicator = defineComponent<{
  label: string;
}>(
  (props) => {
    return () => {
      return (
        <div class="inline-flex items-center gap-2.5">
          <span class="relative flex h-2 w-2">
            <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-400 opacity-75"></span>
            <span class="relative inline-flex rounded-full h-2 w-2 bg-primary-500"></span>
          </span>
          <span
            class="text-sm font-medium font-['Inter'] leading-none bg-clip-text text-transparent animate-text-shimmer"
            style={{
              backgroundImage:
                "linear-gradient(90deg, var(--color-primary-700) 0%, var(--color-primary-700) 40%, var(--color-primary-300) 50%, var(--color-primary-700) 60%, var(--color-primary-700) 100%)",
              backgroundSize: "200% 100%",
            }}
          >
            {props.label}
          </span>
        </div>
      );
    };
  },
  { props: ["label"] },
);
